/* istanbul ignore file */
/* It's not possible to fill VGS fields in Cypress */
import { Accordion } from '@distribusion/owl-frontend-ui'
import { Field } from 'formik'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Response } from '@api/reservation/checkCard'
import utils from '@lib/utils'
import InputField from '@ui/Input/Field'

import '@pages/Checkout/Payment/CheckPayment/index.scss'

export interface Props {
  fields: Response['customFields']
}

export const CustomFields = ({ fields }: Props): ReactElement => {
  const { t } = useTranslation()
  return (
    <Accordion title={t('checkCard.header')} divider={false} opened>
      <div className="custom-fields">
        {fields?.map(({ id, name }) => {
          const fieldName = `creditCardCustomFields.${name}`
          const placeholder = t(`checkCard.customFields.${utils.string.toCamelcase(name)}`, name)
          return <Field key={id} component={InputField} name={fieldName} placeholder={placeholder} />
        })}
      </div>
    </Accordion>
  )
}
